import React from "react";
import { connect } from "react-redux";
import { Button, Form, Row, Col } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import { reduxFormInput } from "components/form/ReduxForm";
import { required, noSpaces } from "utils/validation";
import Spacer from "components/layout/Spacer";

class CreateTermSheetConfirmation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: true,
    };

    this.submitFn = this.submitFn.bind(this);
  }

  submitFn(data) {
    const { onSubmit } = this.props;
    onSubmit(data);
  }

  render() {
    const { onCancel, handleSubmit } = this.props;

    return (
      <Form className="no-border" onSubmit={handleSubmit(this.submitFn)}>
        <Row>
          <Col xs="12">
            <p>
              Thank you for your Quote. Once submitted the terms will be
              available to the borrower. You can cancel, update, or edit the
              term sheet at anytime.
            </p>
            <Spacer size={50} />
          </Col>

          <Col xs={{ span: 10, offset: 1 }}>
            <p>This term sheet will be saved in you account as:</p>
            <Spacer size={20} />

            <div className="d-flex align-items-center justify-content-between">
              <Field
                hideLabel
                disabled={this.state.disabled}
                className="form-control0"
                wrapperClassName="w-100"
                component={reduxFormInput}
                validate={[required, noSpaces]}
                name="name"
                type="text"
                placeholder="Term sheet - [Deal Name] - [Todays Date]"
              />
              <Button
                variant="primary outline border-0 text-nowrap ml-3 px-0"
                onClick={() => {
                  this.setState({ disabled: false });
                }}
              >
                edit name
              </Button>
            </div>

            <Spacer size={50} />
          </Col>

          <Col className="text-right" xs="12">
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="submit" variant="tertiary" className="ml-3">
              Submit Term Sheet
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    whoami: state.auth.whoami,
    initialValues: {
      name: props.data?.termsheetName,
    },
  };
}

export default connect(mapStateToProps)(
  reduxForm({
    form: "CreateTermSheetConfirmation",
    enableReinitialize: true,
  })(CreateTermSheetConfirmation)
);
